import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class UserTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "levelColumn", title: "Level" },
        { name: "rightsColumn", title: "Nutzerrechte" }
      ],
      rows: [
        { levelColumn: 'Admin', rightsColumn: 'Dieser Benutzer besitzt alle Rechte und kann alle Einstellungen ändern.' },
        { levelColumn: 'Benutzer', rightsColumn: 'Ein User kann Einstellungen verändern, die das Kamerabild betreffen. Systemeinstellungen können nicht geändert werden.' },
        { levelColumn: 'Gast', rightsColumn: 'Gast-Benutzer sind als Besucher gedacht und werden dazu benutzt um den Video-Stream der Kamera anzusehen. Sie sollten den Gast-Zugang verwenden, wenn Sie den Video-Stream in eine öffentliche Webseite einbauen möchten.' }
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

UserTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(UserTable)